(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["noohi-welcome"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('noohi-welcome')) {
    customElements.define('noohi-welcome', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        this.dialog = this.querySelector('dialog');
        this.tab = this.querySelector('.noohi-welcome__tab');
        this.form = this.querySelector('form');
        this.key = 'noohi-welcome-v1';
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.tab.addEventListener('click', () => this.open(), options);
        this.querySelectorAll('[data-welcome-close]').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const box = this.dialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) this.dialog.close();
        }, options);
        this.dialog.addEventListener('close', () => {
          document.documentElement.classList.remove('noohi-welcome-open');
          this.write(this.key, this.subscribed ? 'subscribed' : 'dismissed');
          this.tab.hidden = this.subscribed;
          if (!this.subscribed) this.tab.focus({ preventScroll: true });
        }, options);
        this.form.addEventListener('submit', () => {
          try { sessionStorage.setItem(this.key + '-pending', String(Date.now())); } catch (_) {}
        }, options);
        document.addEventListener('shopify:section:select', event => {
          if (event.detail.sectionId === this.dataset.sectionId) this.open();
        }, options);
        let pending = false;
        try { pending = Date.now() - Number(sessionStorage.getItem(this.key + '-pending') || 0) < 1200000; } catch (_) {}
        const returned = pending || location.hash === '#' + this.form.id;
        if (returned && this.querySelector('[data-welcome-success]')) {
          this.subscribed = true;
          this.write(this.key, 'subscribed');
          try { sessionStorage.removeItem(this.key + '-pending'); } catch (_) {}
          this.open();
        } else if (returned && this.querySelector('[data-welcome-errors]')) {
          this.open();
        } else if (this.read(this.key) !== 'subscribed') {
          this.tab.hidden = false;
          if (!this.read(this.key) && this.dataset.designMode !== 'true') this.schedule();
        }
      }
      read(key) { try { return localStorage.getItem(key); } catch (_) { return this.memory; } }
      write(key, value) { this.memory = value; try { localStorage.setItem(key, value); } catch (_) {} }
      schedule() {
        this.timer = setTimeout(() => {
          if (!this.isConnected || this.read(this.key)) return;
          const active = document.activeElement;
          const busy = document.hidden || document.querySelector('dialog[open], .m-modal--open, .m-drawer--open') || active?.matches('input,textarea,select');
          if (busy) { this.schedule(); return; }
          this.open();
        }, Math.max(2, Number(this.dataset.delay) || 5) * 1000);
      }
      open() {
        clearTimeout(this.timer);
        if (this.dialog.open) return;
        this.tab.hidden = true;
        this.dialog.showModal();
        document.documentElement.classList.add('noohi-welcome-open');
      }
      disconnectedCallback() {
        clearTimeout(this.timer);
        this.abort?.abort();
        document.documentElement.classList.remove('noohi-welcome-open');
        this.bound = false;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
